import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Export Salary Data as Excel
export const exportSalaryExcel = (filters = {}) => async (dispatch, getState) => {
  const {
    userLogin: { userInfo },
  } = getState();

  const config = {
    headers: { Authorization: `Bearer ${userInfo.token}` },
    responseType: 'blob',
  };

  const queryParams = new URLSearchParams(filters).toString();
  const response = await axios.get(
    `${API_URL}/salary/export?${queryParams}`,
    config
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  const month = filters.month || 'all';
  const year = filters.year || 'all';
  link.setAttribute('download', `salary-data-${month}-${year}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Export Bank Sheet as TXT
export const exportBankSheetTXT = (data) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: 'blob', // Important for file download
    };

    const response = await axios.post(
      `${API_URL}/export/bank-sheet-txt`,
      data,
      config
    );

    // Create blob and download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `bank-sheet-${data.month}-${data.year}.txt`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true };
  } catch (error) {
    throw new Error(
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message
    );
  }
};

// Export Bank Sheet as Excel (HDFC format)
export const exportBankSheetExcel = (data) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: 'blob',
    };

    const response = await axios.post(
      `${API_URL}/export/bank-sheet-excel`,
      data,
      config
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `bank-sheet-${data.month}-${data.year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true };
  } catch (error) {
    throw new Error(
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message
    );
  }
};

// Export Verification Report Bank Sheet as TXT
export const exportVerificationBankSheetTXT = (data) => async (_dispatch, getState) => {
  try {
    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userInfo.token}` },
      responseType: 'blob',
    };
    const response = await axios.post(`${API_URL}/export/verification-bank-sheet-txt`, data, config);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `verification-bank-sheet-${data.month}-${data.year}.txt`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    return { success: true };
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      let msg = text;
      try { msg = JSON.parse(text).message || text; } catch {}
      throw new Error(msg);
    }
    throw new Error(error.response?.data?.message || error.message);
  }
};

// Export Verification Report Bank Sheet as DOC
export const exportVerificationBankSheetDOC = (data) => async (_dispatch, getState) => {
  try {
    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userInfo.token}` },
      responseType: 'blob',
    };
    const response = await axios.post(`${API_URL}/export/verification-bank-sheet-doc`, data, config);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `verification-bank-sheet-${data.month}-${data.year}.doc`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    return { success: true };
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      let msg = text;
      try { msg = JSON.parse(text).message || text; } catch {}
      throw new Error(msg);
    }
    throw new Error(error.response?.data?.message || error.message);
  }
};

// Export Verification Report Bank Sheet as XLSX (bank portal format)
export const exportVerificationBankSheetXLSX = (data) => async (_dispatch, getState) => {
  try {
    const { userLogin: { userInfo } } = getState();
    const config = {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userInfo.token}` },
      responseType: 'blob',
    };
    const response = await axios.post(`${API_URL}/export/verification-bank-sheet-xlsx`, data, config);
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `verification-bank-sheet-${data.month}-${data.year}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    return { success: true };
  } catch (error) {
    if (error.response?.data instanceof Blob) {
      const text = await error.response.data.text();
      let msg = text;
      try { msg = JSON.parse(text).message || text; } catch {}
      throw new Error(msg);
    }
    throw new Error(error.response?.data?.message || error.message);
  }
};

// Export Bank Sheet as DOC
export const exportBankSheetDOC = (data) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.token}`,
      },
      responseType: 'blob', // Important for file download
    };

    const response = await axios.post(
      `${API_URL}/export/bank-sheet-doc`,
      data,
      config
    );

    // Create blob and download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `bank-sheet-${data.month}-${data.year}.doc`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return { success: true };
  } catch (error) {
    throw new Error(
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message
    );
  }
};
